import React from "react";

import DocuSignAgreementDialog from "./findMeATenant/DocuSignAgreementDialog";
import { AGREEMENT_TYPES } from "../../hooks/useDocuSignAgreements";

const BlanketAgreementDialog = ({ open, onClose, onAgreed, uid, email, fullName }) => (
  <DocuSignAgreementDialog
    open={open}
    onClose={onClose}
    onAgreed={onAgreed}
    uid={uid}
    email={email}
    fullName={fullName}
    agreementType={AGREEMENT_TYPES.BLANKET_SERVICE}
    title="Service Agreement"
    description="Before placing your first order, please read and sign the Master Service Agreement via DocuSign. You only need to do this once — it covers all future Find Me A Tenant orders on your account."
  />
);

export default BlanketAgreementDialog;